module.exports = {
  get,
  set
}

function get(key){
  if (localStorage[key] !== undefined){
    return localStorage[key]
  }
  return undefined;
}

function set(key, value){
  localStorage[key] = value;
  return localStorage[key]
}



// WEBPACK FOOTER //
// ./src/common/local_storage.js